import { request } from "../utils";
import { getCompanyId } from "../utils/globalUtils";
import qs from "qs";

export const getList = (params = {}) => request(`/downstream-companies/${getCompanyId()}/suppliers?${qs.stringify(params)}`);

export const getSingle = supplierId =>  request(`/downstream-companies/${getCompanyId()}/suppliers/${supplierId}`);
